export default "__VITE_ASSET__e2a808a0__"